import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SoftwareCard from "./SoftwareCard";

import { createSoftware, downloadSoftware, getSoftwares } from "./api";
import axios, { secondAxios } from "../../../api/axios";
import CreateDialog from "./CreateDialog";
import { AuthContext } from "../../../context/authContext";
import ManageDialog from "./ManageDialog.jsx";
import DownloadingCard from "./DownloadingCard.jsx";
import SharepointSoftwareCard from "./ShapointSoftwareCard.jsx";

const SoftwarePage = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const { auth } = useContext(AuthContext);
  const currentUser = auth;
  console.log(currentUser?.role);
  const [formData, setFormData] = useState({
    selectedFile: null,
    name: "",
    repository: "",
    description: "",
  });

  const [softwares, setSoftwares] = useState({});

  useEffect(() => {
    const fetchSoftwares = async () => {
      await getSoftwares().then((res) => {
        setSoftwares(res);
      });
    };
    fetchSoftwares();
  }, []);

  const handleFileChange = (event) => {
    setFormData({ ...formData, selectedFile: event.target.files[0] });
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleUpload = async () => {
    const { selectedFile, name, description, repository } = formData;
    const formDataObject = new FormData();
    formDataObject.append("image", selectedFile);
    formDataObject.append("name", name);
    formDataObject.append("description", description);
    formDataObject.append("repository", repository);

    try {
      await createSoftware(formDataObject);
      setOpenDialog(false);
      // console.log('Image uploaded:', response.data);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  const sharepointSoftwares = [
    // {
    //   id: 1,
    //   title: "pressure Vessel",
    //   description: "Design software for pressure vessels",
    //   link: "https://chinookdt189.sharepoint.com/:u:/s/CDTProjectsInternalDevelopment-1006-PressureVesselSoftware-Inventor/EQN3QBlIOHhPh1BdmX6W-_4Baf1dHwKjdzI7RerhM_hIBw?e=WmSWg8",
    // },
    // {
    //   id: 2,
    //   title: "Ga Configurator",
    //   //   description: "Design software for pressure vessels",
    //   link: "https://chinookdt189-my.sharepoint.com/personal/omar_mokhtar_chinookdt_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fomar%5Fmokhtar%5Fchinookdt%5Fcom%2FDocuments%2FLatest%20Setup%20Files%2FGA%20Configurator%20Setup%2Eexe&parent=%2Fpersonal%2Fomar%5Fmokhtar%5Fchinookdt%5Fcom%2FDocuments%2FLatest%20Setup%20Files&ga=1",
    // },
    {
      id: 1,
      title: "FreeCAD",
      description: "FreeCAD software for engineering design",
      link: "https://chinookdt189-my.sharepoint.com/:u:/g/personal/ahmed_samy_chinookdt_com/IQAN1UVymtp8Sql_SwGfEFl8AbgQjYriC_i9gGXIdIHRDeA?e=xMeZbz",
    },
  ];

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleDownload = async (software) => {
    console.log("ot Id", software);
    // await downloadSoftware(id)
    //     .then(response => {
    //         console.log("downloaded")
    //         console.log(response)
    //     })
    setIsDownloading(true);
    try {
      const response = await secondAxios
        .get(`/software/download/${software.id}`, {
          responseType: "blob",
        })
        .then((res) => {
          var blob = new Blob([res.data], { type: "application/octet-stream" });
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          console.log("created a");
          a.href = url;
          a.download = `${software.name}.zip`;
          a.click();
          console.log("got response");
          window.URL.revokeObjectURL(url);
        });
    } catch (error) {
      console.error("Error downloading software:", error);
      setIsDownloading(false);
    } finally {
      setIsDownloading(false);
    }
  };

  console.log({ isDownloading });

  const handleSaveRow = async (software) => {};
  const handleCreateRow = async (software) => {};

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        // backgroundColor: "white",
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Heading */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: "primary.main", fontWeight: 400 }}
        >
          Softwares
        </Typography>
        {currentUser?.role === "owner" ? (
          <Button
            variant="outlined"
            size="small"
            onClick={() => setOpenDialog(true)}
          >
            Manage
          </Button>
        ) : (
          <></>
        )}
      </Box>
      {isDownloading ? <DownloadingCard /> : <></>}
      <Grid container spacing={2} direction="row" sx={{ mt: 1, mb: 1 }}>
        {sharepointSoftwares?.map((software, i) => (
          <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
            <SharepointSoftwareCard
              title={software?.title}
              description={software?.description}
              link={software?.link}
              key={i}
            />
          </Grid>
        ))}
      </Grid>
      {/* Dialog to manage software */}
      <CreateDialog
        openDialog={openDialog}
        formData={formData}
        handleClose={handleClose}
        handleChange={handleChange}
        handleUpload={handleUpload}
        handleFileChange={handleFileChange}
      />
      {/* TODO: Manage Software Dialog to Create/update */}
      {/* <ManageDialog
                openDialog={openDialog}
                handleClose={handleClose}
                data={softwares}
                handleSaveRow={handleSaveRow}
                handleCreateRow={handleCreateRow}
            /> */}
    </Box>
  );
};

export default SoftwarePage;
